import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { 
    ROUTE_ADMINISTRATION_GROUP,
    DOSAGE_FORM_GROUP,
    ROUTE_ADMINISTRATION,
    DOSAGE_FORM, 
    DISPENSING_UNIT,
    UNSPSC,
    UNSPSC_FAMILY,
    UNSPSC_CLASS,
    ACTIVE_INGREDIENT_CODE20,
    DOSAGE_FORM_CODE20,
    MED_DESCRIPTION_CODE22,
    SOURCE_CODE22,
    ANIO_PRICE_CODE22,
    UNIT_PRICE,
    UNIT_PRICE_TRANSACCIONES,
    BASKET
} from '../actions';

import {
    RouteAdministrationGroupSuccess,
    RouteAdministrationGroupError,
    DosageFormGroupSuccess,
    DosageFormGroupError,
    RouteAdministrationSuccess,
    RouteAdministrationError,
    DosageFormSuccess,
    DosageFormError,
    DispensingUnitSuccess,
    DispensingUnitError,
    UnspscSuccess,
    UnspscError,
    UnspscFamilySuccess,
    UnspscFamilyError,
    UnspscClassSuccess,
    UnspscClassError,
    ActiveIngredientCode20Success,
    ActiveIngredientCode20Error,
    DosageFormCode20Success,
    DosageFormCode20Error,
    MedDescriptionCode22Success,
    MedDescriptionCode22Error,
    SourceCode22Success,
    SourceCode22Error,
    AnioPriceCode22Success,
    AnioPriceCode22Error,
    UnitPriceSuccess,
    UnitPriceError,
    UnitPriceTransaccionesSuccess,
    UnitPriceTransaccionesError,
    BasketSuccess,
    BasketError
} from '../actions';


export function* watchRouteAdministrationGroup() {
    yield takeEvery(ROUTE_ADMINISTRATION_GROUP, onRouteAdministrationGroup);
}

export function* watchDosageFormGroup() {
    yield takeEvery(DOSAGE_FORM_GROUP, onDosageFormGroup);
}

export function* watchRouteAdministration() {
    yield takeEvery(ROUTE_ADMINISTRATION, onRouteAdministration);
}

export function* watchDosageForm() {
    yield takeEvery(DOSAGE_FORM, onDosageForm);
}

export function* watchDispensingUnit() {
    yield takeEvery(DISPENSING_UNIT, onDispensingUnit);
}

export function* watchUnspsc() {
    yield takeEvery(UNSPSC, onUnspsc);
}

export function* watchUnspscFamily() {
    yield takeEvery(UNSPSC_FAMILY, onUnspscFamily);
}

export function* watchUnspscClass() {
    yield takeEvery(UNSPSC_CLASS, onUnspscClass);
}

export function* watchActiveIngredientCode20() {
    yield takeEvery(ACTIVE_INGREDIENT_CODE20, onActiveIngredientCode20);
}

export function* watchDosageFormCode20() {
    yield takeEvery(DOSAGE_FORM_CODE20, onDosageFormCode20);
}

export function* watchMedDescriptionCode22() {
    yield takeEvery(MED_DESCRIPTION_CODE22, onMedDescriptionCode22);
}

export function* watchSourceCode22() {
    yield takeEvery(SOURCE_CODE22, onSourceCode22);
}

export function* watchAnioPriceCode22() {
    yield takeEvery(ANIO_PRICE_CODE22, onAnioPriceCode22);
}

export function* watchUnitPrice() {
    yield takeEvery(UNIT_PRICE, onUnitPrice);
}

export function* watchUnitPriceTransacciones() {
    yield takeEvery(UNIT_PRICE_TRANSACCIONES, onUnitPriceTransacciones);
}

export function* watchBasket() {
    yield takeEvery(BASKET, onBasket);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onRouteAdministrationGroupAsync = async () => {
  let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/route_administration_group', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
    return { data:response };
};

const onDosageFormGroupAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/dosage_form_group', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
    return { data: response };
};

const onRouteAdministrationAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/route_administration', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onDosageFormAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/dosage_form', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onDispensingUnitAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/dispensing_unit', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onUnspscAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/unspsc', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onUnspscFamilyAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/unspsc_family', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onUnspscClassAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/unspsc_class', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onActiveIngredientCode20Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/active_ingredient_code20', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onDosageFormCode20Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/dosage_form_code20', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};


const onMedDescriptionCode22Async = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/med_description_code22', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onSourceCode22Async = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/source_code22', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onAnioPriceCode22Async = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/anio_price_code22', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onUnitPriceAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/unit_price', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onUnitPriceTransaccionesAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/unit_price', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onBasketAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'catalogList/basket', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

function* onRouteAdministrationGroup(data) {
  try {
      const response = yield call(onRouteAdministrationGroupAsync, data);
      yield put(RouteAdministrationGroupSuccess(response.data));
  } catch (error) {
      yield put(RouteAdministrationGroupError(error));
  }
}

function* onDosageFormGroup(data) {
    try {
        const response = yield call(onDosageFormGroupAsync, data);
        yield put(DosageFormGroupSuccess(response.data));
    } catch (error) {
        yield put(DosageFormGroupError(error));
    }
}

function* onRouteAdministration(data) {
    try {
        const response = yield call(onRouteAdministrationAsync, data);
        yield put(RouteAdministrationSuccess(response.data));
    } catch (error) {
        yield put(RouteAdministrationError(error));
    }
}

function* onDosageForm(data) {
    try {
        const response = yield call(onDosageFormAsync, data);
        yield put(DosageFormSuccess(response.data));
    } catch (error) {
        yield put(DosageFormError(error));
    }
}

function* onDispensingUnit(data) {
    try {
        const response = yield call(onDispensingUnitAsync, data);
        yield put(DispensingUnitSuccess(response.data));
    } catch (error) {
        yield put(DispensingUnitError(error));
    }
}

function* onUnspsc(data) {
    try {
        const response = yield call(onUnspscAsync, data);
        yield put(UnspscSuccess(response.data));
    } catch (error) {
        yield put(UnspscError(error));
    }
}

function* onUnspscFamily(data) {
    try {
        const response = yield call(onUnspscFamilyAsync, data);
        yield put(UnspscFamilySuccess(response.data));
    } catch (error) {
        yield put(UnspscFamilyError(error));
    }
}

function* onUnspscClass(data) {
    try {
        const response = yield call(onUnspscClassAsync, data);
        yield put(UnspscClassSuccess(response.data));
    } catch (error) {
        yield put(UnspscClassError(error));
    }
}

function* onActiveIngredientCode20(data) {
    try {
        const response = yield call(onActiveIngredientCode20Async, data);
        yield put(ActiveIngredientCode20Success(response.data));
    } catch (error) {
        yield put(ActiveIngredientCode20Error(error));
    }
}

function* onDosageFormCode20(data) {
    try {
        const response = yield call(onDosageFormCode20Async, data);
        yield put(DosageFormCode20Success(response.data));
    } catch (error) {
        yield put(DosageFormCode20Error(error));
    }
}

function* onMedDescriptionCode22(data) {
    try {
        const response = yield call(onMedDescriptionCode22Async, data);
        yield put(MedDescriptionCode22Success(response.data));
    } catch (error) {
        yield put(MedDescriptionCode22Error(error));
    }
}

function* onSourceCode22(data) {
    try {
        const response = yield call(onSourceCode22Async, data.payload);
        yield put(SourceCode22Success(response.data));
    } catch (error) {
        yield put(SourceCode22Error(error));
    }
}

function* onAnioPriceCode22(data) {
    try {
        const response = yield call(onAnioPriceCode22Async, data.payload);
        yield put(AnioPriceCode22Success(response.data));
    } catch (error) {
        yield put(AnioPriceCode22Error(error));
    }
}

function* onUnitPrice(data) {
    try {
        const response = yield call(onUnitPriceAsync, data.payload);
        yield put(UnitPriceSuccess(response.data));
    } catch (error) {
        yield put(UnitPriceError(error));
    }
}

function* onUnitPriceTransacciones(data) {
    try {
        const response = yield call(onUnitPriceTransaccionesAsync, data.payload);
        yield put(UnitPriceTransaccionesSuccess(response.data));
    } catch (error) {
        yield put(UnitPriceTransaccionesError(error));
    }
}

function* onBasket(data) {
    try {
        const response = yield call(onBasketAsync, data);
        yield put(BasketSuccess(response.data));
    } catch (error) {
        yield put(BasketError(error));
    }
}

export default function* rootSaga() {
  yield all([
      fork(watchRouteAdministrationGroup),
      fork(watchDosageFormGroup),
      fork(watchRouteAdministration),
      fork(watchDosageForm),
      fork(watchDispensingUnit),
      fork(watchUnspsc),
      fork(watchUnspscFamily),
      fork(watchUnspscClass),
      fork(watchActiveIngredientCode20),
      fork(watchDosageFormCode20),
      fork(watchMedDescriptionCode22),
      fork(watchSourceCode22),
      fork(watchAnioPriceCode22),
      fork(watchUnitPrice),
      fork(watchUnitPriceTransacciones),
      fork(watchBasket)
  ]);
}